import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class HoldingsOverlapService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getOverlapKeyStats(primarySecurityId, secondarySecurityId, holdingsLayer) {
        const url = this.urlsService.getUrl(this.urlsService.SECURITIES.HOLDINGS_OVERLAP, {
            primarySecurityId,
            secondarySecurityId,
            holdingsLayer,
        });
        return this.ajaxService.getDataObserveBody(url);
    }
    getCommonHoldings(primarySecurityId, secondarySecurityId, page, sortBy, sortDirection, holdingsLayer) {
        const queryParams = { page, sortBy, sortDirection, holdingsLayer };
        const url = this.urlsService.getUrl(this.urlsService.SECURITIES.HOLDINGS_OVERLAP_COMMON_HOLDINGS, {
            primarySecurityId,
            secondarySecurityId,
        }, queryParams);
        return this.ajaxService.getDataObserveBody(url);
    }
    getCommonHoldingsComparisonExportUrl(primarySecurityId, secondarySecurityId, page, sortBy, sortDirection, holdingsLayer) {
        const queryParams = { page, sortBy, sortDirection, holdingsLayer };
        return this.urlsService.getUrl(this.urlsService.SECURITIES.HOLDINGS_OVERLAP_COMMON_HOLDINGS_EXPORT, {
            primarySecurityId,
            secondarySecurityId,
        }, queryParams);
    }
    getTopHoldings(securityId, limit, holdingsLayer) {
        const queryParams = { limit, holdingsLayer };
        const url = this.urlsService.getUrl(this.urlsService.SECURITIES.TOP_HOLDINGS, { securityId }, queryParams);
        return this.ajaxService.getDataObserveBody(url);
    }
    getHoldingsOverlapPDFExportUrl(primarySecurityId, secondarySecurityId, holdingsLayer, exposureViewType, commonHoldingsTableSorting) {
        let queryParams = {};
        if (commonHoldingsTableSorting) {
            const { sortDirection, sortColumn } = commonHoldingsTableSorting;
            queryParams = { sortDirection, sortColumn };
        }
        return this.urlsService.getUrl(this.urlsService.SECURITIES.HOLDINGS_OVERLAP_PDF_REPORT, {
            primarySecurityId,
            secondarySecurityId,
            holdingsLayer,
            exposureViewType,
        }, queryParams);
    }
}
HoldingsOverlapService.ɵfac = function HoldingsOverlapService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HoldingsOverlapService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
HoldingsOverlapService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: HoldingsOverlapService, factory: HoldingsOverlapService.ɵfac, providedIn: 'root' });
